import React, { ChangeEvent, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import HeroProducts from '../../assets/heros/hero-products.png';
import HeroBanner from '../../components/HeroBanner';
import environment from '../../environment';
import StyledConfiguration from './styles';
import ControlledInput from '../../components/ControlledInput';
import CustomButton from '../../components/CustomButton';
import DownloadIcon from '../../assets/icons/download.svg';

const ProductPresetAddOns: React.FC = () => {
  const [rowData, setRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [gridApi, setGridApi] = useState<GridApi>();
  const [quickFilter, setQuickFilter] = useState<string>('');

  const getRowData = async (gridApiParam: GridApi) => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${environment.apiPath}getConfigItems?page=productaddon`,
        {
          ...environment.params
        }
      );

      setRowData(res.data);

      if (res.data.length === 0) {
        gridApiParam?.showNoRowsOverlay();
      }
    } catch (err: AxiosError | any) {
      setRowData([]);
      toast.error(err.message);
      gridApiParam?.showNoRowsOverlay();
    } finally {
      setIsLoading(false);
    }
  };

  const handleDataExport = () => {
    gridApi?.exportDataAsExcel({
      fileName: 'ProductPresentAddons.xlsx'
    });
  };

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    getRowData(params.api);
  };

  const columnDefs = [
    {
      headerName: 'Target Product',
      field: 'targetProduct',
      enableRowGroup: true,
      cellClass: 'stringType'
    },
    {
      headerName: 'Target Product Name',
      field: 'targetProductName',
      enableRowGroup: true
    },
    {
      headerName: 'Add-on Product',
      field: 'addOnProduct',
      enableRowGroup: true,
      cellClass: 'stringType'
    },
    {
      headerName: 'Add-on Product Name',
      field: 'addOnProductName',
      enableRowGroup: true
    },
    {
      headerName: 'Origin',
      field: 'origin',
      enableRowGroup: true
    },
    {
      headerName: 'Segment',
      field: 'segment',
      enableRowGroup: true
    },
    {
      headerName: 'Add-on Backorder',
      field: 'addOnBackorder',
      valueGetter: (params: any) =>
        params.data ? (params.data.addOnBackorder ? 'Y' : 'N') : ''
    },
    {
      headerName: 'Status',
      field: 'active',
      valueGetter: (params: any) =>
        params.data ? (params.data.active ? 'Active' : 'Inactive') : '',
      enableRowGroup: true
    }
  ];

  return (
    <>
      <HeroBanner title='Product Present Add-ons' background={HeroProducts} />
      <StyledConfiguration fixed>
        <div className='configuration__actions'>
          <ControlledInput
            id='quick-filter'
            placeholder='Filter any column'
            value={quickFilter}
            handleChange={(event: ChangeEvent<HTMLInputElement>) => {
              setQuickFilter(event.target.value);
              gridApi?.setGridOption('quickFilterText', event.target.value);
            }}
            label='Grid filter'
            type='text'
            classes='label--w-30'
          />
          <div>
            <CustomButton
              type='button'
              classes='btn--w-200-px btn--black'
              title='Export'
              endIcon={<img src={DownloadIcon} alt='Download configuration' />}
              handleClick={handleDataExport}
            />
          </div>
        </div>
        <div className='configuration__grid ag-theme-balham'>
          <AgGridReact
            rowHeight={30}
            loading={isLoading}
            defaultColDef={{
              resizable: true,
              flex: 1,
              minWidth: 100,
              filter: 'agTextColumnFilter'
            }}
            enableCellTextSelection
            pagination
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            rowGroupPanelShow='always'
            suppressDragLeaveHidesColumns
            excelStyles={[
              {
                id: 'stringType',
                dataType: 'String'
              }
            ]}
          />
        </div>
      </StyledConfiguration>
    </>
  );
};

export default ProductPresetAddOns;
